export default {
  noSupportMemberDoc: {
    issues: [
      {
        id: 'I-DEM-SUP-1000',
        domain: 'DPFC'
      }
    ],
    triggerValue: true
  },
  // relationship: {
  //   unDocumented: {
  //     issues: [
  //       { id: 'I-DEM-SUP-1100',
  //        domain: 'DPFC'
  //       }
  //     ]
  //   }
  // },
  firstName: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-SUP-1200',
          domain: 'DPFC'
        }
      ]
    }
  },
  lastName: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-SUP-1300',
          domain: 'DPFC',
          isDynamic: true,
          dynamicParameters: {
            name: 'firstName',
            relationship: 'relationship'
          }
        }
      ]
    }
  },
  caregiverPrimary: {
    valueExists: {
      issues: [
        {
          id: 'I-DEM-SUP-1400',
          domain: 'DPFC'
        }
      ],
      triggerValue: true
    }
  },
  // emergency: {
  //   valueExists: {
  //     issues: [
  //       { id: 'I-DEM-SUP-1600',
  //        domain: 'DPFC'
  //      },
  //      { id: 'I-DEM-SUP-1700',
  //       domain: 'DPFC'
  //      }
  //     ],
  //     triggerValue: true
  //   }
  // },
  // poa: {
  //   valueExists: {
  //     issues: [
  //       { id: 'I-DEM-SUP-1800',
  //        domain: 'DPFC'
  //      },
  //      { id: 'I-DEM-SUP-1900',
  //       domain: 'DPFC'
  //      }
  //     ],
  //     triggerValue: true
  //   }
  // },
  strainedRelationship: {
    issues: [
      {
        id: 'I-DEM-SUP-2000',
        domain: 'DPFC',
        isDynamic: true,
        dynamicParameters: {
          name: 'firstName',
          relationship: 'relationship'
        }
      }
    ],
    triggerValue: 'yes'
  },
  adequateSupport: {
    issues: [
      {
        id: 'I-DEM-SUP-2300',
        domain: 'DPFC',
        isDynamic: true,
        dynamicParameters: {
          name: 'firstName',
          relationship: 'relationship'
        }
      }
    ],
    triggerValue: 'no'
  },
  differentCareGoals: {
    issues: [
      {
        id: 'I-DEM-SUP-2200',
        domain: 'DKC',
        isDynamic: true,
        dynamicParameters: {
          name: 'firstName',
          relationship: 'relationship'
        }
      }
    ],
    triggerValue: 'yes'
  },
  adequateSupportCaregiver: {
    issues: [
      {
        id: 'I-DEM-SUP-2100',
        domain: 'DKC',
        isDynamic: true,
        dynamicParameters: {
          name: 'firstName',
          relationship: 'relationship'
        }
      }
    ],
    triggerValue: 'no'
  },
  helpProvidingCare: {
    issues: [
      {
        id: 'I-DEM-SUP-2400',
        domain: 'DPFC',
        isDynamic: true,
        dynamicParameters: {
          name: 'firstName',
          relationship: 'relationship'
        }
      }
    ],
    triggerValue: 'yes'
  }
}
